import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  max-width: 1360px;

  display: flex;
  justify-content: center;

  max-height: 440px;

  div {
    width: 100%;
    height: inherit;
    max-height: 440px;

    @media (max-width: 850px) {
      max-height: 300px;
    }

    img {
      object-fit: cover;
      @media (max-width: 550px) {
        object-position: 25% 20px;
        width: 450px !important;
        height: 350px !important;
        max-width: initial !important;
        max-height: initial !important;
      }
    }
  }
`;
